import { FONT_STYLES } from '@/styles/fonts'
import { SUGGESTION_IMAGES } from './images'

const suggestionImages = SUGGESTION_IMAGES

export default function SuggestionsGrid() {
  return (
    <section className="w-full min-h-screen py-20 px-4 bg-black">
      <div className="max-w-7xl mx-auto">
        <h2
          className="text-4xl font-semibold mb-12 text-center tracking-wide uppercase text-white"
          style={FONT_STYLES.pioneer}
        >
          Travel Suggestions
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {suggestionImages.map((item, index) => (
            <div
              key={index}
              className="relative rounded-lg overflow-hidden h-64 group cursor-pointer"
            >
              <img
                src={item.src}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3
                  className="text-white text-xl font-semibold tracking-wide"
                  style={FONT_STYLES.alga}
                >
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

